import { Injectable } from '@angular/core';

@Injectable()
export class SessionService {
    public static readonly KEY_2FA_POPUP_CLOSED: string = 'KEY_2FA_POPUP_CLOSED';

    setItem(key: string, value: string): void {
        sessionStorage.setItem(key, value);
    }

    getItem(key: string): any {
        const data = sessionStorage.getItem(key);
        return data ? data : null;
    }

    setObjectItem(key: string, value: any): void {
        sessionStorage.setItem(key, JSON.stringify(value));
    }

    getObjectItem(key: string): any {
        const data = sessionStorage.getItem(key);
        return data ? JSON.parse(data) : null;
    }

    removeItem(key: string): void {
        sessionStorage.removeItem(key);
    }

    clear(): void {
        sessionStorage.clear();
    }
}
